/**
 * Minicart Complementary Products - uses Search & Discovery complementary recommendations
 * Native slider (no Owl) for multiple items.
 */
(function() {

  function formatMoney(cents) {
    if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents);
    }
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function fetchComplementary(productId) {
    var root = (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root.replace(/\/$/, '') : '';
    return fetch(root + '/recommendations/products.json?product_id=' + productId + '&intent=complementary&limit=10')
      .then(function(r) { return r.json(); })
      .then(function(data) { return data.products || []; })
      .catch(function() { return []; });
  }

  function renderProductCard(p, cartProductIds) {
    if (cartProductIds.indexOf(p.id) !== -1) return '';
    var img = (p.featured_image && (typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src)) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var price = formatMoney(p.price);
    var variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
    var available = p.available !== false && p.variants && p.variants[0] && p.variants[0].available !== false;
    var addBtn = available && variantId
      ? '<button type="button" class="minicart-complementary__add" data-variant-id="' + variantId + '">Add to cart</button>'
      : '<a href="' + p.url + '" class="minicart-complementary__add">View</a>';
    var title = (p.title || '').replace(/</g, '&lt;');
    return '<div class="line-item minicart-complementary__item">' +
      '<div class="content">' +
      '<div class="item-image">' +
      '<a href="' + p.url + '">' +
      (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<div class="minicart-complementary__image-placeholder"></div>') +
      '</a></div>' +
      '<div class="item-details">' +
      '<h4 class="item-title"><a href="' + p.url + '">' + title + '</a></h4>' +
      '<div class="item-price"><div class="text-left"><strong>' + price + '</strong></div></div>' +
      '<div class="minicart-complementary__add-wrap">' + addBtn + '</div>' +
      '</div></div></div>';
  }

  function loadMinicartComplementary() {
    var widget = document.getElementById('minicart-complementary');
    var carouselEl = document.getElementById('minicart-complementary-carousel');
    if (!widget || !carouselEl) return;

    fetch((typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root ? Shopify.routes.root.replace(/\/$/, '') : '') + '/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (!cart.items || cart.items.length === 0) {
          widget.style.display = 'none';
          return;
        }
        var productIds = [];
        var cartProductIds = [];
        for (var i = 0; i < cart.items.length; i++) {
          var pid = cart.items[i].product_id;
          if (productIds.indexOf(pid) === -1) productIds.push(pid);
          cartProductIds.push(pid);
        }
        return Promise.all(productIds.map(fetchComplementary))
          .then(function(results) {
            var seen = {};
            var products = [];
            for (var j = 0; j < results.length; j++) {
              for (var k = 0; k < results[j].length; k++) {
                var prod = results[j][k];
                if (!seen[prod.id] && cartProductIds.indexOf(prod.id) === -1) {
                  seen[prod.id] = true;
                  products.push(prod);
                }
              }
            }
            if (products.length === 0) {
              widget.style.display = 'none';
              return;
            }
            var html = products.map(function(p) { return renderProductCard(p, cartProductIds); }).join('');
            var multi = products.length > 1;
            if (multi) {
              carouselEl.innerHTML = '<div class="minicart-complementary__track">' + html + '</div>';
              carouselEl.classList.add('minicart-complementary__carousel--multi');
              var wrap = widget.querySelector('.minicart-complementary__slider-wrap');
              var prev = wrap && wrap.querySelector('.minicart-complementary__prev');
              var next = wrap && wrap.querySelector('.minicart-complementary__next');
              var track = carouselEl.querySelector('.minicart-complementary__track');
              if (prev) prev.style.display = '';
              if (next) next.style.display = '';
              function scrollBy(direction) {
                if (!track) return;
                var step = (track.querySelector('.minicart-complementary__item') || {}).offsetWidth || track.clientWidth;
                if (step) step += 10;
                track.scrollBy({ left: direction * step, behavior: 'smooth' });
              }
              if (prev) prev.onclick = function() { scrollBy(-1); };
              if (next) next.onclick = function() { scrollBy(1); };
            } else {
              carouselEl.innerHTML = html;
              carouselEl.classList.remove('minicart-complementary__carousel--multi');
              var wrap = widget.querySelector('.minicart-complementary__slider-wrap');
              var prev = wrap && wrap.querySelector('.minicart-complementary__prev');
              var next = wrap && wrap.querySelector('.minicart-complementary__next');
              if (prev) prev.style.display = 'none';
              if (next) next.style.display = 'none';
            }
            widget.style.display = 'block';

            var loadingSpinnerHtml = '<div class="spinner" style="display:block;"><div class="fa-pulse"><i class="fa fa-spinner fa-3x fa-fw"></i></div></div>';
            carouselEl.querySelectorAll('.minicart-complementary__add[data-variant-id]').forEach(function(btn) {
              btn.addEventListener('click', function(e) {
                e.preventDefault();
                var vid = this.getAttribute('data-variant-id');
                if (!vid) return;
                var loadingEl = document.getElementById('minicart-panel-items-loading');
                if (loadingEl) {
                  loadingEl.innerHTML = loadingSpinnerHtml;
                  loadingEl.classList.add('minicart-loading-visible');
                }
                btn.disabled = true;
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: vid, quantity: 1 })
                }).then(function(r) { return r.json(); })
                  .then(function() {
                    if (typeof loadMinicart !== 'undefined') {
                      loadMinicart(function() {
                        if (loadingEl) loadingEl.classList.remove('minicart-loading-visible');
                        btn.disabled = false;
                      });
                    } else {
                      if (loadingEl) loadingEl.classList.remove('minicart-loading-visible');
                      btn.disabled = false;
                    }
                  })
                  .catch(function(err) {
                    console.error(err);
                    if (loadingEl) loadingEl.classList.remove('minicart-loading-visible');
                    btn.disabled = false;
                  });
              });
            });
          });
      })
      .catch(function() { widget.style.display = 'none'; });
  }

  window.loadMinicartComplementary = loadMinicartComplementary;
})();
